import { useContext, useState } from 'react';
import { Box } from '@mui/material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';

import { Check } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import {
    AppContext,
    SttButton,
    SttButtonAccept,
} from '../../../../sporttia/all';
import { useShareGame } from '../../../../lib/hooks';
import { Game } from '../../../../types/models/Game';
import ShareGameDialog from './ShareGameDialog';

interface ActionsProps {
    game: Game;
    emailSent: boolean;
    onOpenSignupDialog: () => void;
    facilityCapacity: number;
    canAddMorePlayers: boolean;
}

export default function Actions({
    game,
    emailSent,
    onOpenSignupDialog,
    facilityCapacity,
    canAddMorePlayers,
}: ActionsProps) {
    const { t } = useTranslation();
    const cxt = useContext(AppContext)!;

    const [openShare, setOpenShare] = useState(false);

    const {
        snackbarOpen,
        setSnackbarOpen,
        copyLoading,
        handleCopyShareText,
        handleShareWhatsApp,
        handleShareTwitter,
    } = useShareGame(game);

    const isPastGame = game && new Date(game.ini) < new Date();

    return (
        <Box mb={2}>
            {!game.players.some(
                (player) => player.user.id === cxt.user?.id,
            ) && (
                <SttButtonAccept
                    fullWidth
                    caption={
                        emailSent
                            ? t('view.recoverPassword.sendEmail')
                            : t('signupForMatch')
                    }
                    onClick={onOpenSignupDialog}
                    startIcon={emailSent ? <PersonAddIcon /> : <Check />}
                    disabled={
                        game.players.length >= facilityCapacity ||
                        emailSent ||
                        isPastGame ||
                        !canAddMorePlayers
                    }
                    style={{ marginBottom: 12 }}
                />
            )}
            <SttButton
                fullWidth
                caption={t('shareMatch')}
                onClick={() => setOpenShare(true)}
                startIcon={<ShareOutlinedIcon />}
                style={{ marginBottom: 12 }}
            />
            <ShareGameDialog
                open={openShare}
                onClose={() => setOpenShare(false)}
                translate={t}
                copyLoading={copyLoading}
                handleCopyShareText={handleCopyShareText}
                handleShareWhatsApp={handleShareWhatsApp}
                handleShareTwitter={handleShareTwitter}
                snackbarOpen={snackbarOpen}
                setSnackbarOpen={setSnackbarOpen}
            />
        </Box>
    );
}
